import { EndpointName } from '~/store/middlewares/rtkErrorNotifier/rtkErrorNotifier.type';

export const isWhitelistedEndpoint = (endpointName: string) => {
  const whitelistedEndpoints: EndpointName[] = [];

  return whitelistedEndpoints.includes(endpointName as EndpointName);
};
